import React from "react";
import { motion } from "framer-motion";
import "../../components/Team/Team.css";
import Teamimg1 from '../../assets/images/team1.png';
import Teamimg2 from '../../assets/images/team2.png';
import '../../styles/CustomClassCss/Custom.css';

const Team = () => {
  const teamMembers = [
    {
      name: "Rahul Sharma",
      position: "COO",
      image: Teamimg1,
    },
    {
      name: "Pradeep Thakur ",
      position: "MD",
      image: Teamimg2,
    },
    // {
    //   name: "Shankar Sunderraman ",
    //   position: "CEO",
    //   image: Teamimg2,
    // },
  ];

  const contentVariant = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 1.2, ease: "easeInOut" },
    },
  };

  const imageVariant = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 1.2, ease: "easeInOut" },
    },
  };

  return (
    <div className="meet-our-team custom-inner-space custom-container-upper">
      <div className="team-header">
        <h2 className="meet-top font-poppins">04. Meet Our Team</h2>
        {/* <a href="#" className="view-all">
          VIEW ALL
        </a> */}
      </div>

      <motion.div
        className="team-grid"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        {teamMembers.map((member, index) => (
          <motion.div className="team-member" key={index}>
            <motion.div
              className="image-container"
              variants={imageVariant}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
            >
              <img src={member.image} alt={member.name} />
            </motion.div>
            <motion.div
              className="info"
              variants={contentVariant}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
            >
              <span className="position font-rubik">{member.position}</span>
              <h3 className="name font-space-grotesk">{member.name}</h3>
            </motion.div>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
};

export default Team;
